import Constant from "../constants";
import { mainWrapper } from "./main";

const HomePageService = {
    homePage,
};

function homePage() {
    return mainWrapper.get(Constant.host + "/home-page");
}


export default HomePageService;
